import * as React from 'react';
import * as styles from './styles.css';

export interface ISpecialPromoPinProps {
  imageUrl: string;
  backgroundColor?: string | null;
}

export function SpecialPromoPin({ imageUrl, backgroundColor }: ISpecialPromoPinProps) {
  return (
    <div className={styles['container']}>
      <div
        className={styles['label']}
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundColor: backgroundColor || undefined,
        }}
      />
      <div className={styles['pin']} />
    </div>
  );
}
